const MAX_RECORDS_COUNT = 6;

let _lastActions = [];

export const track = action => {
	let stringAction = action.type;

	if (_lastActions.length <= MAX_RECORDS_COUNT) {
		_lastActions = [..._lastActions, stringAction];
	} else {
		_lastActions = [..._lastActions.splice(1, _lastActions.length), stringAction];
	}
}
export const getLastActions = () => _lastActions
